import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccordianItem from '../AccordianItem';

class Accordian extends Component {
  constructor (props) {
    super(props);
    this.itemClickHandler = this.itemClickHandler.bind(this);
    this.state = {
      selectedId: 1
    };
  }
  itemClickHandler (id) {
    this.setState({
      selectedId: id
    });
  }
  render () {
    return (
      <ul className='screenshot-explainer js-screenshot-explainer' id='screenshotExplainer'>
        {
          this.props.items.map((i) => (
            <AccordianItem item={i} selectedId={this.state.selectedId} handleItemClick={this.itemClickHandler} key={i.id} />
          ))
        }
      </ul>
    );
  }
}

Accordian.propTypes = {
  items: PropTypes.array
};

export default Accordian;



// WEBPACK FOOTER //
// ./src/components/Accordian/index.js